<template>
  <b-card title="Wallets">
    <b-overlay :show="loadingData" variant="transparent" no-wrap />
    <!-- modal edit-->
    <b-modal
      no-close-on-backdrop
      ref="my-modal"
      id="modal-wallet"
      centered
      hide-footer
      title="Currencies"
    >
      <b-form @submit.prevent="addCurrencyWallet">
        <b-form-group label="Currencies">
          <v-select
            v-model="walletSelected.currencies"
            placeholder="Currencies"
            label="abbreviation"
            multiple
            :options="dataCurrencys"
          />
        </b-form-group>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
        >
          Submit
        </b-button>
      </b-form>
    </b-modal>

    <b-modal
      v-if="formData"
      ref="my-modal"
      id="modal-show-wallet"
      centered
      hide-footer
      :title="`Username: ${formData.user.username}`"
    >
      <div>
        status: <b-badge pill :variant="formData.status ? 'success' : 'danger'" class="text-white" slot="">{{ formData.status ? "Active" : "Unactive" }}</b-badge>
      </div>

      <div>
        transactions: <strong>{{ formData.transactions.length }}</strong>
      </div>

      <div>
        currencies: <strong>{{ formData.currencies.length }}</strong>
      </div>

      <div>
        user: <strong>{{ formData.user.name }}</strong>
      </div>

      <div>
        client: <strong>{{ formData.user.client }}</strong>
      </div>
    </b-modal>

    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
          <b-button
            class="text-nowrap ml-2"
            variant="primary"
            @click="$refs.addUpdateWallet.modalShow = true"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap">Add</span>
          </b-button>
          <add-update-whallet @addWallet="getWallets()" ref="addUpdateWallet" />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
    class="table-responsive"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Action -->
        <div class="d-flex justify-content-center" v-if="props.column.field === 'actionTransacion'">
          <b-button
              variant="primary"
              @click="showTransactions({ walletId: props.row._id, walletName: props.row.walletName })"
              class="mr-1"
              size="sm"
          >
            See all
          </b-button>
          <b-button
              variant="success"
              @click="showCreditDebitMod(props.row)"
              size="sm"
          >
            Credit/Debit
          </b-button>

          
        </div>

        <span v-if="props.column.field === 'action'">
          <!-- clase para centar dos div -->
          <div class="d-flex justify-content-center ">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              class="dropdown-icon-wrapper"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                />
              </template>
              
              <b-dropdown-item
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-show-wallet
                @click="formData = props.row"
                variant="outline-primary"
              >
                <feather-icon icon="EyeIcon" class="mr-50" />
                <span>Show</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-wallet
                @click="editCurrencyWallet(props.row)"
                variant="outline-primary"
              >
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteWallet(props.row._id)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
                  
          </div>
        </span>

        <!-- Column: Common -->
          <span v-if="props.column.field === 'currencies' && props.row.balance">
            <v-select
              @input="previewBalance($event, props.row._id)"
              :value="props.row.balance.currency"
              placeholder="select currency"
              label="currency"
              :reduce="(item) => item.currency"
              :options="props.row.currencies"
              :clearable="false"
            >
            </v-select>
          </span>
          
          <span v-else-if="props.column.field === 'balance' && props.row.balance">
            {{props.row.balance.balance | currency({ symbol: ''})}}
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['20', '40', '60', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <Transaction  ref="transactionsByWallet"/>
    <CreditDebitMod ref="CreditDebitMod" />
  </b-card>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  VBModal,
  BForm,
  BCard,
  BOverlay,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import { mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
import Transaction from "./Transaction";
import vSelect from "vue-select";
import AddUpdateWhallet from "./addUpdateWhallet.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import CreditDebitMod from "./CreditDebitMod.vue"

export default {
  components: {
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    VBModal,
    Transaction,
    BForm,
    vSelect,
    BCard,
    BOverlay,
    AddUpdateWhallet,
    ToastificationContent,
    CreditDebitMod
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      dataCurrencys: [],
      walletSelected: {},
      formData: {
        user: {
          name: null,
          client: null,
        },
        transactions: [],
        currencies: [],
        balance: 0,
      },
      pageLength: 20,
      dir: false,
      columns: [
        {
          label: "username",
          field: "user.username",
        },
        {
          label: "client",
          field: "user.client.name",
        },
        {
          label: "currencies",
          field: "currencies",
        },
        {
          label: "balance",
          field: "balance",
        },
        {
          label: "transaccion",
          field: "actionTransacion",
        },
        {
          label: "action",
          field: "action",
        },
      ],
      searchTerm: "",
      loadingData: false,
      walletName: ""
    };
  },
  computed: {
    rows() {
      // return getter  module wallets
      return this.$store.getters["wallet/getWallets"];
    },
  },
  methods: {
    ...mapActions("wallet", ["balance", "destroy", "show"]),
    ...mapActions("currency", ["currencys"]),
    async getWallets() {
      try {
        this.loadingData = true;
        await this.$store.dispatch("wallet/wallets");
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching wallet list",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      } finally {
        this.loadingData = false;
      }
    },
    editCurrencyWallet(wallet) {
      this.walletSelected = JSON.parse(JSON.stringify(wallet));
      this.walletSelected.currencies = this.walletSelected.currencies.map((currency) => currency.currency);
      this.getcurrencys();
    },
    async addCurrencyWallet() {
      try {
        this.loadingData = true;
        await this.$store.dispatch("wallet/addCurrency", this.walletSelected);
        this.$bvModal.hide("modal-wallet");
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Success",
            icon: "AlertTriangleIcon",
            variant: "success",
            text: `Currency added`,
          },
        });
        this.getWallets();
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error adding currency",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      } finally {
        this.loadingData = false;
      }

    },
    async getcurrencys() {
      const res = await this.currencys();
      this.dataCurrencys = res.map((currency) => {
        return currency.abbreviation;
      });
    },
    async previewBalance(currency, walletId) {
       await this.balance({
        walletId: walletId,
        currencyId: currency,
      });
    },
    async deleteWallet(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          this.deleteProduct(id);
        }
      });
    },

    async deleteProduct(id) {
      try {
        this.loadingData = true;
        const res = await this.$store.dispatch("wallet/destroy", id);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Wallet successfully removed",
            icon: "CheckCircleIcon",
            variant: "success",
            text: `${res.message}`,
          },
        });
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error delete wallet",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      } finally {
        this.loadingData = false;
      }
    },
    async updateForm() {
      console.log(this.formData.currencies);
    },
    showCreditDebitMod(wallet) {
      this.$refs.CreditDebitMod.showCreditDebitMod({wallet});
    },
    showTransactions({walletId, walletName}) {
      this.$refs.transactionsByWallet.showTransactions({walletId, walletName});
    },
    },
  mounted() {
    this.getWallets();
  },
};
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>